module.exports = __webpack_public_path__ + "img/home_yy_s_icon.4596191.png";